import React from "react";
import queryString from "query-string";
import { Form, Progress, Alert } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = "vero";
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: "",
      },
      username: "",
      password: "",
    };
  }

  componentDidMount() {
    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message,
      },
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: "",
      },
    });


    const usernameBase64 = btoa(`toolbox${this.usernameInput.value}`)

    this.props.api
      .userPassLogin(
        {
          username: this.usernameInput.value,
          password: this.passwordInput.value,
          usernameBase64
        },
        this.parameters
      )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location =
          this.parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const translate = this.props.translate(error.errorCode);

        let message = "Senha errada. Tente novamente.";

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }

        this.setState({
          onLogin: false,
          error: { open: true, message: message },
        });
      });
  }

  render() {
    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <div className="vero-login-container" ref={this.ref}>
          <div className="login-head">
            <h1>Login</h1>
          </div>
          <div className="login-body">
            <Form onSubmit={(event) => this.onSubmit(event)}>
              <div className="form-group">
                <label className="vero-label">Login:</label>
                <input
                  disabled={this.state.onLogin}
                  type="text"
                  className="form-control input-login-vero"
                  placeholder="CPF ou CNPJ"
                  required={true}
                  ref={(ref) => {
                    this.usernameInput = ref;
                  }}
                  tabIndex={1}
                  autoCorrect="off"
                  autoCapitalize="none"
                  name="username"
                />
              </div>
              <div className="form-group ">
                <label className="vero-label">Senha:</label>
                <input
                  type="password"
                  className="form-control input-pass-vero"
                  placeholder="Senha"
                  required={true}
                  disabled={this.state.onLogin}
                  ref={(ref) => {
                    this.passwordInput = ref;
                  }}
                  autoCorrect="off"
                  autoCapitalize="none"
                  name="password"
                  tabIndex={1}
                />
              </div>
              <p className="pass-reset">
                <a
                  href="https://verointernet.com.br/esqueceu-senha/#/login"
                  target="_blank"
                  without
                  rel="noopener noreferrer"
                >
                  Esqueci minha senha
                </a>
              </p>
              {!this.state.onLogin ? (
                <button type="submit" className="btn btn-vero" disabled={!this.props.turnstileSuccess}>
                  Entrar
                </button>
              ) : (
                <Progress animated color="danger" value={100} />
              )}
              <div className="messages-container">
                <Alert color="danger" id="error-message" isOpen={this.state.error.open} toggle={() => this.setState({ error: { open: false } })}>
                  {this.state.error.message}
                </Alert>
              </div>
              <this.props.TurnstileComponent setTurnstileSuccess={this.props.setTurnstileSuccess} />
            </Form>
          </div>
        </div>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
